// extracted by mini-css-extract-plugin
module.exports = {"detailBlock":"TeamReportTimeSpent_detailBlock__3jUI4","name":"TeamReportTimeSpent_name__2PdJo"};